<template>
    <v-app ref="app">
            <TestModule v-if="currentModule ==='TestModule'" ref="TestModule"/>
            <ExpenseSheetsModule v-if="currentModule === 'ExpenseSheetsModule'" ref="ExpenseSheetsModule"/>
            <ExpenseSheetDetailDialog v-if="currentModule === 'ExpenseSheetDetailDialog'" ref="ExpenseSheetDetailDialog"/>   
             <ProjectsModule v-if="currentModule === 'ProjectsModule'" ref="ProjectsModule"/>
						<!--<DialogManager ref="DialogManager" v-on:refresh="refreshModule"/>  -->
    </v-app>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import TestModule from './components/modules/TestModule'
import ExpenseSheetsModule from './components/modules/expensesheets/ExpenseSheetsModule'
import ExpenseSheetDetailDialog from './components/modules/expensesheets/ExpenseSheetDetailDialog'
import ProjectsModule from './components/modules/projects/ProjectsModule'
import moment from 'moment';
//import DialogManager from './components/modules/DialogManager'

//import { EventBus }  from './components/util/event-bus'
//import gwt from './api/gwt'

export default {
  name: 'App',
  components: {
    TestModule, ExpenseSheetsModule, ExpenseSheetDetailDialog, ProjectsModule/*, DialogManager*/
  },

  data () {
      return { 
          currentModule: 'TestModule'
      }
    },
  mounted: function ()  {
      let me = this;
      this.$nextTick(() => {
            window.$vueBridge = me;
            me.$refs.app.$el.firstChild.style.minHeight="100%";
    });
      
    /*EventBus.$on('widget-data-click',payload => {
        if (payload.mode==='VUEDIALOG') {
          me.$refs.DialogManager.processEvent( payload.mode, payload.type,payload.action,payload.payload, payload.eventConfig);
        } else {
          gwt.processEvent( payload.mode, payload.type,payload.action,payload.payload);
        }
      });*/
  },
  methods: {
    applyLocale(locale)
    {
      this.$i18n.locale = locale;
      moment.locale(locale);
    },
    getCurrentModule() {
        return this.currentModule;
    },
    refreshModule() {
      if (this.currentModule && this.$refs[this.currentModule] && this.$refs[this.currentModule].refreshModule) {
        this.$refs[this.currentModule].refreshModule();
      }
    },
    showModule(module,payload) {
        let me = this;
        me.currentModule = module;
        this.$nextTick(() => {
						if (me.$refs[module].onReveal) {
								me.$refs[module].onReveal(payload);
						}
        });
    }
  }
}
</script>
